export function toTitleCase(string?: string): string {
  if (!string) {
    return '';
  }
  return string.replace(/(?:^|\s)\S/g, (match) => {
    return match.toUpperCase();
  });
}
